import {
  Box,
  Typography,
  Grid2,
  Stack,
  Button,
  Divider
} from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { useGetComapanyOwnersQuery } from "../../../api/userApi";
import { LoadingIndicator } from "../../shared/alerts/loadingIndicator";
import { FC } from "react";
import { useAuthenticatedUser } from "../../../hooks/useAuthenticatedUser";
import { Add } from "@mui/icons-material";
import { Collection } from "../../../enums/collections.enum";
import { OwnerListView } from "./ownerListView";

export const OwnersListByCompanyContainer: FC = () => {
  const { companyId } = useParams<{ companyId?: string }>();
  const { isAdmin } = useAuthenticatedUser();

  const {
    data: users = [],
    isLoading: loading,
    error: rawError,
  } = useGetComapanyOwnersQuery({ companyId }, {
    skip: !companyId,
  });

  if (loading) {
    return <LoadingIndicator message="Loading company owners..." />
  }

  if (!companyId) {
    return <div>Company not found</div>
  }

  if (rawError) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", marginTop: 4 }}>
        <Typography color="error">Error: {String(rawError)}</Typography>
      </Box>
    );
  }

  return (
    <Grid2>

      {isAdmin && <Stack direction="row" justifyContent="space-between" alignItems="center" mr={2}>
        <Typography variant="h5" >
        </Typography>
        <Button
          variant="contained"
          startIcon={<Add />}
          component={Link}
          to={`/${Collection.Companies}/${companyId}/${Collection.Users}/add`}
        >
          Add Owner
        </Button>

      </Stack>}
      <Divider>Company Owners</Divider>
      <OwnerListView
        users={users}
        companyId={companyId}
      />
    </Grid2>
  );
};

